import { useSettings } from "./use-settings";
import { useCurrentUserData } from "../user-data";
import { usePermissionCheck, Permission } from "../use-auth";

export const useGpmSettingsCheck = () => {
  const { settings } = useSettings();
  const { currentUser } = useCurrentUserData({ cache: false });
  const gpmOverride = usePermissionCheck(Permission.GPM_OVERRIDE);
  const showGpm =
    (!settings?.restrictGpmVisibility || currentUser?.restrictedGpmVisible || gpmOverride) ?? false;

  return {
    showGpm,
    showGpmSlider: !showGpm || (settings?.showGpmSlider ?? false),
  };
};
